import { Card as MuiCard, CardProps as MuiCardProps, SxProps, Theme, Typography, useMediaQuery } from "@mui/material";
import { ReactNode, forwardRef } from "react";
import { Box, Stack } from "../../components";
import { useTheme } from "../../hooks";

type CardProps = MuiCardProps & {
  header?: ReactNode;
  fullHeight?: boolean;
  headerSx?: SxProps<Theme>;
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ sx, header, fullHeight, onClick, headerSx, children, ...rest }, ref) => {
    const theme = useTheme();
    const upSm = useMediaQuery(theme.breakpoints.up("sm"));

    const renderBodyContent = () => {
      return (
        <Box
          p={4}
          flexGrow={1}
          overflow="auto"
          sx={{
            "&:hover": {
              backgroundColor: onClick ? theme.palette.action.hover : undefined,
              cursor: onClick ? "pointer" : "unset",
            },
          }}
        >
          {children}
        </Box>
      );
    };

    return (
      <MuiCard
        ref={ref}
        sx={{
          ...sx,
          display: "flex",
          flexDirection: "column",
          overflow: fullHeight ? "auto" : "unset",
          height: fullHeight ? "100%" : "auto",
          borderRadius: upSm ? "10px" : "0",
        }}
        onClick={onClick}
        {...rest}
      >
        {header && (
          <Box
            display="grid"
            alignItems={"center"}
            sx={{ ...headerSx }}
            borderBottom={1}
            borderColor={theme.palette.border.main}
            px={3.5}
            minHeight={50}
            fontSize={"1.15rem"}
            //fontWeight={"light"}
          >
            {header}
          </Box>
        )}

        {renderBodyContent()}
      </MuiCard>
    );
  }
);
